import { Box, styled } from '@mui/material';

import { Spacing } from 'Themes/spacing';

export const StyledLogo = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${Spacing.small};
`;
